import { MainContainer } from '@/components/battle/MainContainer';
import { Leaderboard } from '@/components/leaderboard/Leaderboard';
import { bgSounds } from '@/lib/sounds';
import InitBackground from '../../images/leaderboard-bg.png';
import { useMusic } from '@/components/Sounds/useMusic';

export const BattleLeaderboardPage = () => {
  useMusic(bgSounds.leaderboard);

  return (
    <MainContainer
      padding={0}
      background={InitBackground}
      backgroundPosition="top"
      backgroundSize="100% auto"
    >
      <Leaderboard />
    </MainContainer>
  );
};
